var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: 'InstanceStatus', params:{ workflowName: _vm.scope.row.workflowName, caseId:_vm.scope.row.caseId }}}},[_vm._v("\n  "+_vm._s(_vm.scope.row.workflowName)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }